import { useCallback } from 'react'
import { useUpdateAbTestAssignmentsMutation } from 'src/participant/patientQueries.generated'
import { AbTestInput } from 'src/graphql.generated'

const useUpdateABTestAssignments = (uid: string) => {
  const [updateABTestAssignments] = useUpdateAbTestAssignmentsMutation()

  const handleUpdate = useCallback(
    (abTests: AbTestInput | AbTestInput[]) => updateABTestAssignments({ variables: { uid, abTests } }),
    [uid, updateABTestAssignments]
  )

  return handleUpdate
}

export default useUpdateABTestAssignments
